// reducer.js
import * as types from './actionTypes';

const initialState = {
  stopPayments: null,
  loading: false,
  error: null,
  success: false,
};

const payrollReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_PAYROLL_STOP_PAYMENT_REQUEST:
    case types.SAVE_PAYROLL_STOP_PAYMENT_REQUEST:
      return { ...state, loading: true, error: null,success:false };

    case types.FETCH_PAYROLL_STOP_PAYMENT_SUCCESS:
      return {
        ...state,
        stopPayments: action.payload,
        loading: false,
        success:false
      };

    case types.SAVE_PAYROLL_STOP_PAYMENT_SUCCESS:
      return {
        ...state,
        success: true,
        loading: false,
      };

    case types.FETCH_PAYROLL_STOP_PAYMENT_FAILURE:
    case types.SAVE_PAYROLL_STOP_PAYMENT_FAILURE:
      return {
        ...state,
        error: action.payload,
        loading: false,
        success: false,
      };

    case types.SAVE_REOPEN_PAYMENT:
      return { ...state, loading: true, success: false };
    case types.SAVE_REOPEN_PAYMENT_SUCCESS:
      return { ...state, loading: false, success: true, reopenPayment: action.payload };
    case types.SAVE_REOPEN_PAYMENT_FAILURE:
      return { ...state, loading: false, error: action.payload, success: false, reopenPayment: [] };

    default:
      return state;
  }
};

export default payrollReducer;
